import { ReactNode } from 'react';
import BrandRail from './BrandRail';

interface AppLayoutProps {
  children: ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="relative min-h-screen">
      {/* Brand Rail - Fixed on right side */}
      <BrandRail />
      
      {/* Main Content - Add right padding to account for rail */}
      <div className="pr-12 sm:pr-14 md:pr-16 lg:pr-20 xl:pr-24">
        {children}
      </div>
    </div>
  );
}
